export default {"src":"/_next/static/media/advanced-active.05c60c1a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};